var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVueJs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2500 2165.1",
    viewBox: "0 0 2500 2165.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1538.7 0-288.7 500-288.7-500h-961.3l1250 2165.1 1250-2165.1z",
    fill: "#4dba87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1538.7 0-288.7 500-288.7-500h-461.3l750 1299 750-1299z",
    fill: "#435466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueJs1);
export default __webpack_public_path__ + "static/media/vue-js-1.4921ee763e7954a01fa7d9bc10d1ab93.svg";
export { ForwardRef as ReactComponent };